export type FlexDirectionCSSProps = 'row' | 'row-reverse' | 'column' | 'column-reverse'

export type FlexWrapCSSProps = 'nowrap' | 'wrap' | 'wrap-reverse'

export type AlignItemsCSSProps = 'stretch' | 'start' | 'center' | 'end' | 'baseline'

export type JustifyContentCSSProps = 'start' | 'center' | 'end' | 'space-between' | 'space-around'

export const settings = {
  blockAxis: {
    baseline: 'baseline',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
  },
  inlineAxis: {
    'space-around': 'space-around',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    'space-between': 'space-between',
  },
}

export type Settings = typeof settings

export type AlignmentTheme = typeof settings

export type AlignmentProps = {
  alignItems?: AlignItemsCSSProps | AlignItemsCSSProps[]
  flexDirection?: FlexDirectionCSSProps | FlexDirectionCSSProps[]
  flexWrap?: FlexWrapCSSProps | FlexWrapCSSProps[]
  justifyContent?: JustifyContentCSSProps | JustifyContentCSSProps[]
}
